import { createSelector } from 'reselect';
import { filter, get, has, keyBy, groupBy, min, sumBy } from 'lodash/fp';

function getTicketBonuses(singleChallengeId, pendingEntries, compatibleChallenges, bonuses) {
  if (singleChallengeId) {
    const ticketBonuses = filter(
      bonus => bonus.challenge && bonus.challenge.id === singleChallengeId
    )(bonuses);
    return ticketBonuses.length > 0 ? [ticketBonuses[0]] : [];
  }

  if (pendingEntries) {
    const groupedBonuses = groupBy('challenge.id', bonuses);
    const challenges = keyBy('id', compatibleChallenges);
    const ticketBonuses = [];

    Object.entries(groupedBonuses).forEach(([challengeId, items]) => {
      if (has(challengeId, challenges)) {
        const subtotal = sumBy('value', items);
        const num =
          min([challenges[challengeId].cost * pendingEntries[challengeId], subtotal]) /
          challenges[challengeId].cost;

        for (let i = 0; i < num; i += 1) {
          ticketBonuses.push(items[i]);
        }
      }
    });

    return ticketBonuses;
  }

  return [];
}

const ticketBonusSelector = createSelector(
  get('challenge.id'),
  get('compatibleChallenges.pendingEntries'),
  get('compatibleChallenges.challenges'),
  get('user.currentUser.bonusPack.bonuses'),
  getTicketBonuses
);

export default ticketBonusSelector;
